// src/Admin/pages/Dashboard.jsx
import { useAuth } from "../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import Sidebar from "../../components/Sidebar"; 
// Sidebar is responsive already
import "../../css/Dashboard.css"; // Import Dashboard styles

const Dashboard = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout(() => navigate("/admin-login"));
  };

  return (
    <div className="dashboard-layout">
      <main className="dashboard-main">
        <header className="dashboard-header">
          <div className="header-left">
            <h1>Welcome to Admin Dashboard</h1>
            <p className="subheading">
              Manage your platform efficiently and effectively.
            </p>
          </div>
          <div className="header-right">
            <button className="btn">Profile</button>
            <button className="btn">Notifications</button>
          </div>
        </header>

        <section className="dashboard-content">
          <div className="cardd">
            <h3>Overview</h3>
            <p>
              This is your control center. Navigate through the sidebar to
              manage the admin panel.
            </p>
          </div>
          <div className="cardd">
            <h3>Recent Activities</h3>
            <p>
              Here you can see recent updates or tasks you need to take action
              on.
            </p>
          </div>
        </section>
      </main>
    </div>
  );
};

export default Dashboard;
